import React from 'react'
import TableInput from '../../../dpe-usco/components/Table/TableInput/TableInput'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

const STORAGE_HEADERS = [
  'Name',
  'Cleanout date',
  'Capacity'
]

const storageStructure = {
  headers: STORAGE_HEADERS,
  dataKeys: [
    'location_name', 
    'cleanout_date',
    'capacity'
  ],

  format: {
    location_name: val => {
      return <div data-testid='location_name' className='cell'>{val}</div>
    },
    cleanout_date: (val, onChange) => {
      return (
        <input
          role='grid'
          aria-label='cleanoutDate'
          className='interff w150'
          key='cleanout_date'
          onChange={onChange}
          type='date'
          value={val}
        />
      )
    },
    capacity: (val, onChange) => {
      return (
        <input
          name='CAPACITY'
          aria-label='capacity'
          className='interff w150'
          key='capacity'
          onChange={onChange}
          type='number'
          value={val}
        />
      )
    }
  }
}

export const StorageCleanout = ({ storageData, updateRowData, modalCallBack, isActiveWidget, setIsActiveWidget, status }) => {

  const clickHandler = () => {
    setIsActiveWidget('STORAGE')
  }

  let buttons = (
    <Button disabled={isActiveWidget && isActiveWidget !== 'STORAGE' }  text='Edit storage cleanout' clickHandler={clickHandler} />
  )
  
  if (isActiveWidget === 'STORAGE'){
    buttons = (
      <div className='100% tar'>
        <Button customClassName='mr10' type='default' text='Cancel' clickHandler={() => modalCallBack('DISCARD')}/>
        <Button customClassName='mr10' type='success' text='Save' clickHandler={() => modalCallBack('STORAGE')}/>
      </div>
    )
  } 

  return (
    <Widget dataTestId='storageCleanoutTable' title='Storage Cleanout' button={buttons}>
      <TableInput statusComponent={status ? <TableStatus status={status}/> : null} structure={storageStructure} data={storageData} updateRowData={updateRowData} editMode={isActiveWidget === 'STORAGE'}/>
    </Widget>
  )
}

export default StorageCleanout